import { Breakpoints, css, styled, ThemeDefinition } from "@vw-marketing/us-components";

interface GenericProps {
  theme: ThemeDefinition;
}

export const StyledTopicContainer = styled.div`
  ${({ theme }: GenericProps) => {
    return css`
      align-content: start;
      align-items: start;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: 4px;
      width: 100%;
      padding: ${theme.size.static250} ${theme.size.static150};

      @media (min-width: ${Breakpoints.b1280}px) {
        align-content: center;
        align-items: center;
        flex-direction: row;
        gap: auto;
        padding: ${theme.size.static300} ${theme.size.static250};
      }
    `;
  }}
`;

export const StyledTopicData = styled.div`
  ${({ theme }: GenericProps) => {
    return css`
      align-content: start;
      align-items: start;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      flex: 1;
      gap: ${theme.size.static100};
      justify-content: space-between;
    `;
  }}
`;

export const StyledChannelsContainer = styled.div`
  ${({ theme }: GenericProps) => {
    return css`
      align-content: center;
      align-items: center;
      display: flex;
      flex-wrap: wrap;
      flex: 0.6;
      gap: ${theme.size.static350};
      justify-content: flex-start;
      padding: 12px 0;
      width: 100%;

      @media (min-width: ${Breakpoints.b1280}px) {
        flex-wrap: nowrap;
        justify-content: flex-end;
        padding: 0;
      }
    `;
  }}
`;
